import CurrencyContext from "contexts/CurrencyContext";
import { useContext } from "react";

const useCurrency = () => useContext(CurrencyContext).currency;

export default useCurrency;
